export default () => {
  const filter_sections = document.querySelectorAll('.js-archive-filters');
  if (filter_sections) {
    filter_sections.forEach(element => {
      const filter_toggle = element.querySelector('.js-filters-toggle');
      const filter_list = element.querySelector('.js-filters-list');
      if (filter_toggle) {
        const filter_label = filter_toggle.querySelector('.js-label');
        filter_toggle.addEventListener('click', toggle => {
          document.body.classList.toggle('filter-open');
          element.classList.toggle('is-active');
          toggle.currentTarget.classList.toggle('is-active');
          filter_label.innerText = filter_label.dataset.labelClose;
          if (element.classList.contains('is-active')) {
            filter_label.innerText = filter_label.dataset.labelClose;
            filter_list.style.maxHeight = 'none';
          } else {
            filter_label.innerText = filter_label.dataset.labelOpen;
            filter_list.style.maxHeight = 0;
          }
        })
        window.addEventListener('resize', () => {
          recalculateFilterHeight(element, filter_list);
        });
      }

      let filters = element.querySelectorAll('.wcpf-field-checkbox-list');
      if (filters) {
        filters.forEach(filter => {
          filter.querySelectorAll('.wcpf-checkbox').forEach(item => {
            item.addEventListener('click', () => {
              if (element.classList.contains('is-active')) {
                filter_list.style.maxHeight = 'none';
              }
            })
          })

          filter.querySelectorAll('.wcpf-more-button').forEach(item => {
            item.addEventListener('click', () => {
              if (element.classList.contains('is-active')) {
                filter_list.style.maxHeight = 'none';
              }
            })
          })

          filter.querySelectorAll('.wcpf-checkbox-item').forEach(item => {
            item.addEventListener('change', () => {
              if (element.classList.contains('is-active')) {
                filter_list.style.maxHeight = 'none';
              }
            })
          })
        });
      }
    });
  }
}

const recalculateFilterHeight = (element, filter_list) => {
  if (element.classList.contains('is-active')) {
    filter_list.style.maxHeight = 'none';
  }
}